var map = {
	"./accidents.svg": 1040,
	"./address.svg": 1041,
	"./alert.svg": 1042,
	"./arrow-left.svg": 1043,
	"./arrow-right.svg": 1044,
	"./bus-stop-red.svg": 1045,
	"./bus-stop.svg": 1046,
	"./bus.svg": 1047,
	"./close.svg": 1048,
	"./emergencies.svg": 1049,
	"./environmental_hazards.svg": 1050,
	"./ferry.svg": 1051,
	"./flag.svg": 1052,
	"./incident-jam-black.svg": 1053,
	"./incident-jam.svg": 1054,
	"./incident-roadwork-black.svg": 1055,
	"./incident-roadwork.svg": 1056,
	"./occupancy-empty-inverted.svg": 1057,
	"./occupancy-empty.svg": 1058,
	"./occupancy-few-inverted.svg": 1059,
	"./occupancy-few.svg": 1060,
	"./occupancy-full.svg": 1061,
	"./occupancy-many-inverted.svg": 1062,
	"./occupancy-many.svg": 1063,
	"./occupany-standing-inverted.svg": 1064,
	"./occupany-standing.svg": 1065,
	"./pin.svg": 1066,
	"./platform-change-tag.svg": 1067,
	"./road_conditions.svg": 1068,
	"./road_maintenance.svg": 1069,
	"./route.svg": 1070,
	"./routes.svg": 1071,
	"./search.svg": 1072,
	"./special_events.svg": 1073,
	"./stop.svg": 1074,
	"./technical_issues.svg": 1075,
	"./traffic_jams.svg": 1076,
	"./train.svg": 1077,
	"./two-markers.svg": 1078,
	"./unknown.svg": 1079,
	"./user-manual.svg": 1080,
	"./vehicle_issues.svg": 1081,
	"./weather_environmental_conditions.svg": 1082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 543;